var _rect, _rect2, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPremium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 309,
    height: 62,
    viewBox: "0 0 309 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 309,
    height: 62,
    rx: 16,
    fill: "#FFFDEA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_29796_13392",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 309,
    height: 62
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 309,
    height: 62,
    rx: 16,
    fill: "#FFF8A6"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_29796_13392)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 114.93,
    width: 151.417,
    height: 55.5163,
    transform: "rotate(-40.2257 63 114.93)",
    fill: "url(#paint0_linear_29796_13392)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.332 68C209.796 68 222.332 55.464 222.332 40C222.332 24.536 209.796 12 194.332 12C178.868 12 166.332 24.536 166.332 40C166.332 55.464 178.868 68 194.332 68Z",
    fill: "#FFF8A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.332 60.6316C205.727 60.6316 214.964 51.3945 214.964 39.9999C214.964 28.6053 205.727 19.3682 194.332 19.3682C182.937 19.3682 173.7 28.6053 173.7 39.9999C173.7 51.3945 182.937 60.6316 194.332 60.6316Z",
    fill: "#FFAB57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.289 49.0401L188.234 41.9348L192.401 46.0977L185.289 49.0401ZM194.882 47.787L196.52 43.8145L190.424 37.7318L186.445 39.3809L183.332 36.2682L202.322 29L205.332 32.0075L198.07 51L194.882 47.787Z",
    fill: "#FDE78B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6695 18.8756C75.9751 18.4972 75.3857 17.9518 74.9548 17.2888C74.8337 17.1025 74.6252 16.9918 74.4032 17.0005C74.1812 17.0091 73.9818 17.1356 73.8755 17.3305C73.4972 18.0249 72.9518 18.6143 72.2888 19.0453C72.1025 19.1664 71.9918 19.3749 72.0005 19.5969C72.0091 19.8189 72.1355 20.0182 72.3305 20.1246C73.0249 20.5029 73.6143 21.0483 74.0452 21.7112C74.1663 21.8975 74.3748 22.0082 74.5968 21.9995C74.8188 21.9909 75.0182 21.8644 75.1245 21.6695C75.5028 20.9751 76.0482 20.3857 76.7112 19.9547C76.8975 19.8336 77.0082 19.6251 76.9995 19.4031C76.9909 19.1811 76.8645 18.9819 76.6695 18.8756Z",
    fill: "#FFDFAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.298 23.7335C265.415 23.7311 264.547 23.5088 263.771 23.0869C263.553 22.9683 263.29 22.9705 263.076 23.0971C262.863 23.2236 262.734 23.4536 262.733 23.7016C262.731 24.5845 262.509 25.4534 262.087 26.229C261.968 26.447 261.971 26.7104 262.097 26.9239C262.224 27.1373 262.454 27.2658 262.702 27.2665C263.585 27.2689 264.453 27.4912 265.229 27.9131C265.447 28.0317 265.71 28.0295 265.924 27.9029C266.137 27.7764 266.266 27.5464 266.267 27.2984C266.269 26.4154 266.491 25.5468 266.913 24.7711C267.032 24.5531 267.029 24.2897 266.903 24.0762C266.777 23.8627 266.547 23.7342 266.298 23.7335Z",
    fill: "#FFAB57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6573 45.1372C57.7811 44.4504 57.0897 43.5562 56.6454 42.5355C56.5206 42.2488 56.2569 42.0466 55.9465 42.0071C55.6363 41.9674 55.3302 42.0966 55.1372 42.3428C54.4504 43.2189 53.5562 43.9104 52.5355 44.3546C52.2488 44.4794 52.0467 44.7431 52.0071 45.0535C51.9674 45.3637 52.0966 45.6698 52.3428 45.8628C53.2189 46.5496 53.9104 47.4438 54.3546 48.4645C54.4794 48.7512 54.7432 48.9533 55.0535 48.9929C55.3637 49.0326 55.6699 48.9034 55.8628 48.6572C56.5496 47.7811 57.4438 47.0896 58.4645 46.6454C58.7513 46.5206 58.9534 46.2568 58.993 45.9465C59.0325 45.6362 58.9034 45.3302 58.6573 45.1372Z",
    fill: "#FFF8A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.062 19.806C26.2434 19.3422 26.5375 18.9308 26.9176 18.609C27.0244 18.5186 27.077 18.3795 27.0541 18.2415C27.0311 18.1035 26.9363 17.989 26.806 17.938C26.3422 17.7566 25.9308 17.4625 25.609 17.0824C25.5186 16.9756 25.3796 16.923 25.2415 16.9459C25.1035 16.9689 24.989 17.0637 24.938 17.194C24.7566 17.6578 24.4626 18.0692 24.0825 18.391C23.9757 18.4814 23.9231 18.6204 23.946 18.7585C23.9689 18.8965 24.0637 19.011 24.1941 19.062C24.6578 19.2434 25.0693 19.5374 25.3911 19.9175C25.4815 20.0243 25.6205 20.0769 25.7585 20.054C25.8965 20.0311 26.011 19.9363 26.062 19.806Z",
    fill: "#FFAB57"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_29796_13392",
    x1: 215.149,
    y1: 142.956,
    x2: 84.3082,
    y2: 142.749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAB57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremium);
export default __webpack_public_path__ + "static/media/premium.7b15f36037ba5831aec9d3a1ff6708ee.svg";
export { ForwardRef as ReactComponent };